import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useLocation, useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import CardActionArea from '@mui/material/CardActionArea';
import Box from '@mui/material/Box';
import {
  Icon,
  SvgMultipleUsers2Bold,
  TextV2,
} from '@insights-ltd/design-library/components';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';

const AddLearnersAndContributorsCard = ({
  hasLearner,
  disabled = false,
  learnersCount = 0,
  contributorsCount = 0,
  pastExtendedEndDate,
  isCancelled,
}: {
  hasLearner: boolean;
  disabled: boolean;
  learnersCount: number;
  contributorsCount: number;
  pastExtendedEndDate?: boolean;
  isCancelled?: boolean;
}) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const displayCardText = () => {
    if (pastExtendedEndDate || isCancelled) {
      return 'ui.event-management.events.summary.view-learners-and-contributors';
    }
    if (hasLearner) {
      return 'ui.event-management.events.summary.manage-learners-and-contributors';
    }
    return 'ui.event-management.events.summary.dfc.add-learners-and-contributors';
  };

  const displayCardSubtext = () => {
    if (learnersCount > 0 && contributorsCount <= 0) {
      return t(
        'ui.event-management.events.summary.overview.manage-learners.no-of-learners',
        { count: learnersCount },
      );
    }

    if (contributorsCount > 0) {
      return `${t(
        'ui.event-management.events.overview.summary.no-of-learners',
        {
          count: learnersCount,
        },
      )} ${t('ui.event-management.events.summary.dfc.no-of-contributors', {
        count: contributorsCount,
      })}`;
    }

    return t('ui.event-management.events.summary.get-started');
  };

  return (
    <Card
      elevation={0}
      sx={(theme) => ({
        height: '100%',
        border: `1px solid ${theme.palette.grey[500]}`,
        borderBottom: `0.2em solid ${theme.palette.primary.main}`,
      })}
    >
      <CardActionArea
        onClick={() => navigate(`${pathname}/learners-and-contributors`)}
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          width: '100%',
          height: '100%',
          fontFamily: 'inherit',
        }}
        disabled={disabled}
      >
        <CardContent>
          <Icon
            icon={<SvgMultipleUsers2Bold />}
            iconColour="green"
            iconShape="square"
          />
          <Box
            sx={{
              mb: (theme) => theme.spacing(spacingSizeMap.S),
              mt: (theme) => theme.spacing(spacingSizeMap.S),
            }}
          >
            <TextV2 component="p" variant="h3" color="primary">
              {t(displayCardText())}
            </TextV2>
          </Box>
          <TextV2 variant="bodyBold" color="textSecondary">
            {displayCardSubtext()}
          </TextV2>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default AddLearnersAndContributorsCard;
